import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useMutation } from '@tanstack/react-query';
import { CourierFilesApiAdapter } from '../adapters';
import { InboxRunCourierFilesRequest, InboxRunCourierFilesResponse } from '../models';

export const useRunInboxCourierFiles = () => {
  const mutation = useMutation({
    mutationFn: async (data: InboxRunCourierFilesRequest): Promise<InboxRunCourierFilesResponse> => {
      const httpClient = createHttpClient(apiClientWH);
      const adapter = new CourierFilesApiAdapter(httpClient);
      return adapter.runInboxCourierFiles(data);
    },
  });

  return {
    runInboxAsync: mutation.mutateAsync,
    isRunningInbox: mutation.isPending,
  };
};
